import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invoice-statistics"
export default class extends Controller {
  static targets = ["form", "dateRange", "downloadButton", "downloadText", "spinner"]

  connect() {
    console.log("Invoice Statistics controller connected")
    
    // Initialize the date range picker
    const today = moment();
    const startOfWeek = today.clone().startOf('week');
    const endOfWeek = today.clone().endOf('week');
    
    $(this.dateRangeTarget).daterangepicker({
      opens: 'left',
      startDate: startOfWeek,
      endDate: endOfWeek,
      locale: {
        format: 'YYYY-MM-DD'
      }
    }, 
      (start, end, label) => {
      this.dateRangeTarget.value = start.format('YYYY-MM-DD') + ' - ' + end.format('YYYY-MM-DD');
      this.formTarget.requestSubmit();
    });
    
    // Set initial value
    this.dateRangeTarget.value = startOfWeek.format('YYYY-MM-DD') + ' - ' + endOfWeek.format('YYYY-MM-DD');
  }
  
  startDownload(event) {
    // Show loading state
    this.downloadTextTarget.textContent = "Generando...";
    this.spinnerTarget.classList.remove("hidden");
    this.downloadButtonTarget.classList.add("opacity-75", "cursor-not-allowed");
    this.downloadButtonTarget.setAttribute("disabled", "disabled");
    
    // The download will happen automatically since we're using a regular link
    // After 3 seconds, reset the button state (the file should be downloading by then)
    setTimeout(() => {
      this.downloadTextTarget.textContent = "Descargar Reporte";
      this.spinnerTarget.classList.add("hidden");
      this.downloadButtonTarget.classList.remove("opacity-75", "cursor-not-allowed");
      this.downloadButtonTarget.removeAttribute("disabled");
    }, 3000);
  }
}
